export default __webpack_public_path__ + "static/media/sever.7c59659a.png";